import { createInteractiveColorVar } from '../../helpers/createInteractiveColorVar/index.js';

const ControlBackgroundColors = createInteractiveColorVar('controls-background');
const ControlBackgroundColorsLightValues = Object.freeze({
    default: '#FCFCFC',
    action: '#F7F7F7',
    active: '#EEEEEE',
    activeAction: '#F7F7F7',
});
const ControlBackgroundColorsDarkValues = Object.freeze({
    default: '#121212',
    action: '#212121',
    active: '#2A2A2A',
    activeAction: '#212121',
});

export { ControlBackgroundColors, ControlBackgroundColorsDarkValues, ControlBackgroundColorsLightValues };
